module.exports = __webpack_public_path__ + "static/meganFace-4bac01eff729c0ef1215d66c42a7111b.jpg";